module.exports = __webpack_public_path__ + "static/media/android-1.1f3b46fb.jpg";